import { Card, Divider, Flex, Space, Tabs, Row, Tooltip, Typography, Descriptions } from "antd";
import React, { useState } from "react";
import ResultCard from "../../../../../../components/ResultCard";
// import { LaserClassResults } from "../../../../../components/LaserClassResults";
// import { LaserClassResultsV2 } from "../MPE_AEL_Results/LaserClassResultsV2";
// import LaserClassVerdict from "../MPE_AEL_Results/LaserClassVerdict";
import { Eyewear } from "../../../../../../components/TestAndLabelLinks";
import eye from "../../../../../../assets/Icons/eye black.png"
import hand from "../../../../../../assets/Icons/hand black.png"
import beam from "../../../../../../assets/Icons/beam black.png"
// import { LaserClassResultsDiffuseReflective } from "../MPE_AEL_Results/LaserClassResultsDiffuseReflective";
import { Infograph } from "../../../../../../components/infographicsModal/Infograph";
import { EyewearResults } from "../../../ResultComponents/EyewearResults";
// import { AllAELDiffuse } from "../../../../../../components/AELTab/AllAELDiffuse";
import useFreeMode from "../../../Free/useFreeMode";
import { AllAELANSI } from "../../../../../../components/AELTab/ANSI/AllAELANSI";
import { EyewearResultsANSI } from "../../../ResultComponents/EyewearResultsANSI";
const { Text, Title } = Typography


export function DRResultRepetitivelyPulseANSI({ result, units, laserOperation, data }) {
   
    const { isFree } = useFreeMode('diffuseReflective')
    const { MPE, AE } = result
    const textCenter = { display: 'flex', justifyContent: 'center' }
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [info, setInfo] = useState(null)
    let props = { result: result, data: data, laserOperation: laserOperation }
    const handleClick = (e) => {
        setIsModalOpen(true)
        setInfo(e)
    }
    const handleCancel = () => {
        setIsModalOpen(false)
    }
    return (<Tabs items={[{
        key: 1,
        label: "MPE Details",
        children: (
            <>
                <Tabs centered items={[{
                    key: 1,
                    label: result?.albedo?.num + "% Albedo",
                    children:
                        <>
                            <Infograph
                                isModalOpen={isModalOpen}
                                setIsModalOpen={setIsModalOpen}
                                handleCancel={handleCancel}
                                info={info}
                            />
                            <Card style={{ marginBottom: "20px" }}>
                                <Divider> <h4><img src={eye} width={50} style={{ marginRight: "5px" }} /><strong>EYE</strong></h4></Divider>
                                <Card style={{
                                    backgroundColor: (() => {
                                        if (props.result.MPE?.mostRestrictive === props.result?.MPE?.mpe_multiple_pulse?.num &&
                                            props.result.MPE?.mostRestrictive === props.result?.MPE?.mpe_single?.result.mpeStandard.num)
                                            return "#fcf151"
                                    })()
                                }}>
                                    <Flex justify="space-evenly" wrap="wrap">
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Single Pulse MPE
                                            </strong>
                                            <Tooltip title={"Maximum Permissible Exposure, this value is the level of laser radiation to which, under normal circumstances, the eye may be exposed to a single pulse laser without suffering adverse effects."}>
                                                <Typography style={textCenter}>
                                                    {props?.result?.MPE?.mpe_single?.result?.mpeStandard?.pretty}
                                                    {/* {(() => {
                      if (props.units === 'joules') {
                        return props.result.MPE.single.joulesPerSqmPretty.eng + 'J/m²';
                      } else if (props.units === 'watts') {
                        return props.result.MPE.single.wattsPerSqmPretty.eng + 'W/m²';
                      }
                    })()} */}

                                                </Typography>
                                            </Tooltip>
                                        </Space>
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Accessible Emission
                                            </strong>
                                            <Space>
                                                <Tooltip title={"The value of the Radiant Exposure taking into account the applicable beam area."}>
                                                    <p style={{ "marginBottom": 1, display: 'flex', justifyContent: 'center' }}>AE</p>
                                                    <strong>
                                                        <Typography style={textCenter}>
                                                            {props?.result?.MPE?.mpe_single?.result?.mpeStandard?.unit.includes("W") ? `${props?.result?.AE?.albedo_wattsPerSqmPretty}W/cm²` : `${props?.result?.AE?.albedo_joulesPerSqmPretty}J/cm²`}

                                                            {/* {(() => {
                          if (props.units === 'joules') {
                            return props.result.AE.joulesPerSqmPretty;
                          } else if (props.units === 'watts') {
                            return props.result.AE.wattsPerSqmPretty;
                          }
                        })()} */}
                                                        </Typography>
                                                    </strong>
                                                </Tooltip>
                                                <Divider type="vertical" style={{ height: "40px" }}></Divider>
                                                <Tooltip title={"The value of the Radiant Exposure based on the spot size"}>
                                                    <p style={{ "marginBottom": 1, display: 'flex', justifyContent: 'center' }}>Actual AE</p>
                                                    <strong>
                                                        <Typography style={textCenter}>
                                                            {props?.result?.MPE?.mpe_single?.result?.mpeStandard?.unit.includes("W") ? `${props?.result?.AE?.albedo_wattsPerSqmPretty}W/cm²` : `${props?.result?.AE?.albedo_joulesPerSqmPretty}J/cm²`}

                                                            {/* {(() => {
                          if (props.units === 'joules') {
                            return props.result.AE.actual_joulesPerSqmPretty;
                          } else if (props.units === 'watts') {
                            return props.result.AE.actual_wattsPerSqmPretty;
                          }
                        })()} */}
                                                        </Typography>
                                                    </strong>
                                                </Tooltip>
                                            </Space></Space>
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Eye Safety Ratio
                                            </strong>
                                            <Tooltip title={"The safety margin between the Accessible Emissionand the Maximum Permissible Exposure (MPE) limit for the eye."}>
                                                <strong style={props.result.safetyRatio.single.albedo_joulesPerSqm > 1 ? {
                                                    ...textCenter,
                                                    color: "#d82424"
                                                } : props.result.safetyRatio.single.albedo_joulesPerSqm <= 1 && props.result.safetyRatio.single.albedo_joulesPerSqm >= 0.5 ? {
                                                    ...textCenter,
                                                    color: "#ffa200"
                                                } : props.result.safetyRatio.single.albedo_joulesPerSqm < 0.5 ? {
                                                    ...textCenter,
                                                    color: "#10c96d"
                                                } : null}>
                                                    {props.result.safetyRatio.single.albedo_joulesPerSqmPretty}
                                                </strong>
                                            </Tooltip>
                                        </Space>
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Limit Aperture
                                            </strong>
                                            <Tooltip title={"The diameter of a circular area over which the irradiance or radiant exposure is to be averaged."}>
                                                <Typography style={textCenter}>
                                                    Eye: {props.result?.limitAperture?.eye} mm
                                                </Typography>
                                                <Typography style={textCenter}>
                                                    Skin: {props.result?.limitAperture?.skin} mm
                                                </Typography>
                                            </Tooltip>
                                        </Space>
                                    </Flex>

                                </Card>

                                <Card style={{
                                    backgroundColor: (() => {
                                        if (props.result.MPE?.mostRestrictive === props.result.MPE?.mpe_multiple_pulse?.num &&
                                            props.result.MPE?.mostRestrictive === props.result.MPE?.mpe_single?.result?.mpeStandard?.num) {
                                            return null
                                        }
                                        else if (props.result.MPE?.mostRestrictive === props.result.MPE?.mpe_multiple_pulse?.num &&
                                            props.result.MPE?.mostRestrictive !== props.result.MPE?.mpe_single?.result?.mpeStandard?.num) {
                                            return "#fcf151"
                                        }
                                    })()
                                }}>
                                    <Flex justify="space-evenly" wrap="wrap">
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Pulse Train MPE
                                            </strong>
                                            <Tooltip title={"Maximum Permissible Exposure, this value is the level of laser radiation to which, under normal circumstances, the eye may be exposed to all the pulses for the duration of the exposure time frame without suffering adverse effects."}>
                                                <Typography style={textCenter}>
                                                    {props?.result?.MPE?.mpe_multiple_pulse?.result?.mpeStandard?.pretty}
                                                    {/* {(() => {
                      if (props.units === 'joules') {
                        return props.result.MPE.pulseTrain.joulesPerSqmPretty;
                      } else if (props.units === 'watts') {
                        return props.result.MPE.pulseTrain.wattsPerSqmPretty;
                      }
                    })()} */}
                                                </Typography>
                                            </Tooltip>
                                        </Space>
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Accessible Emission
                                            </strong>
                                            <Space>
                                                <Tooltip title={"The value of the Radiant Exposure taking into account the applicable beam area."}>
                                                    <p style={{ "marginBottom": 1, display: 'flex', justifyContent: 'center' }}>AE</p>
                                                    <strong>
                                                        <Typography style={textCenter}>
                                                            {props?.result?.MPE?.mpe_multiple_pulse?.result?.mpeStandard?.unit.includes("W") ? `${props?.result?.AE?.albedo_wattsPerSqmPretty}W/cm²` : `${props?.result?.AE?.albedo_joulesPerSqmPretty}J/cm²`}

                                                            {/* {(() => {
                          if (props.units === 'joules') {
                            return props.result.AE.joulesPerSqmPretty;
                          } else if (props.units === 'watts') {
                            return props.result.AE.wattsPerSqmPretty;
                          }
                        })()} */}
                                                        </Typography>
                                                    </strong>
                                                </Tooltip>
                                                <Divider type="vertical" style={{ height: "40px" }}></Divider>
                                                <Tooltip title={"The value of the Radiant Exposure based on the spot size"}>
                                                    <p style={{ "marginBottom": 1, display: 'flex', justifyContent: 'center' }}>Actual AE</p>
                                                    <strong>
                                                        <Typography style={textCenter}>
                                                            {props?.result?.MPE?.mpe_multiple_pulse?.result?.mpeStandard?.unit.includes("W") ? `${props?.result?.AE?.albedo_wattsPerSqmPretty}W/cm²` : `${props?.result?.AE?.albedo_joulesPerSqmPretty}J/cm²`}

                                                            {/* {(() => {
                          if (props.units === 'joules') {
                            return props.result.AE.actual_joulesPerSqmPretty;
                          } else if (props.units === 'watts') {
                            return props.result.AE.actual_wattsPerSqmPretty;
                          }
                        })()} */}
                                                        </Typography>
                                                    </strong>
                                                </Tooltip>
                                            </Space></Space>
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Eye Safety Ratio
                                            </strong>
                                            <Tooltip title={"The safety margin between the Accessible Emissionand the Maximum Permissible Exposure (MPE) limit for the eye."}>
                                                <strong style={props.result.safetyRatio?.multiple_pulse.albedo_joulesPerSqm > 1 ? {
                                                    ...textCenter,
                                                    color: "#d82424"
                                                } : props.result.safetyRatio?.multiple_pulse.albedo_joulesPerSqm <= 1 && props.result.safetyRatio?.multiple_pulse.albedo_joulesPerSqm >= 0.5 ? {
                                                    ...textCenter,
                                                    color: "#ffa200"
                                                } : props.result.safetyRatio?.multiple_pulse.albedo_joulesPerSqm < 0.5 ? {
                                                    ...textCenter,
                                                    color: "#10c96d"
                                                } : null}>
                                                    {props.result.safetyRatio?.multiple_pulse.albedo_joulesPerSqmPretty}
                                                </strong>
                                            </Tooltip>
                                        </Space>
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Limit Aperture
                                            </strong>
                                            <Tooltip title={"The diameter of a circular area over which the irradiance or radiant exposure is to be averaged."}>
                                                <Typography style={textCenter}>
                                                    Eye: {props.result?.limitAperture?.eye} mm
                                                </Typography>
                                                <Typography style={textCenter}>
                                                    Skin: {props.result?.limitAperture?.skin} mm
                                                </Typography>
                                            </Tooltip>
                                        </Space>
                                    </Flex>
                                </Card>
                                <Card style={{
                                    backgroundColor: (() => {
                                        if (props.result.MPE?.mostRestrictive === props.result.MPE?.mpe_average.num &&
                                            props.result.MPE?.mostRestrictive === props.result.MPE?.mpe_single.result.mpeStandard.num &&
                                            props.result.MPE?.mostRestrictive === props.result.MPE?.mpe_multiple_pulse?.num) {
                                            return "null"
                                        }
                                        else if (props.result.MPE?.mostRestrictive === props.result.MPE?.mpe_average.num &&
                                            props.result.MPE?.mostRestrictive !== props.result.MPE?.mpe_single.result.mpeStandard.num &&
                                            props.result.MPE?.mostRestrictive !== props.result.MPE?.mpe_multiple_pulse?.num) {
                                            return "#fcf151"
                                        }
                                    })()
                                }}
                                >
                                    <Flex justify="space-evenly" wrap="wrap">
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Average MPE
                                            </strong>
                                            <Tooltip title={"Maximum Permissible Exposure, this value is the level of laser radiation to which the eye may be exposed to all the pulses for the duration of the exposure time frame without suffering adverse effects."}>
                                                <Typography style={textCenter}>
                                                    {props?.result?.MPE?.mpe_average?.result?.mpeStandard?.pretty}
                                                    {/* {(() => {
                      if (props.units === 'joules') {
                        return props.result.MPE.average.joulesPerSqmPretty;
                      } else if (props.units === 'watts') {
                        return props.result.MPE.average.wattsPerSqmPretty;
                      }
                    })()} */}
                                                </Typography>
                                            </Tooltip>
                                        </Space>
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Accessible Emission
                                            </strong>
                                            <Space>
                                                <Tooltip title={"The value of the Radiant Exposure taking into account the applicable beam area."}>
                                                    <p style={{ "marginBottom": 1, display: 'flex', justifyContent: 'center' }}>AE</p>
                                                    <strong>
                                                        <Typography style={textCenter}>
                                                            {props?.result?.MPE?.mpe_average?.result?.mpeStandard?.unit.includes("W") ? `${props?.result?.AE?.albedo_wattsPerSqmPretty}W/cm²` : `${props?.result?.AE?.albedo_joulesPerSqmPretty}J/cm²`}

                                                            {/* {(() => {
                          if (props.units === 'joules') {
                            return props.result.AE.joulesPerSqmPretty;
                          } else if (props.units === 'watts') {
                            return props.result.AE.wattsPerSqmPretty;
                          }
                        })()} */}
                                                        </Typography>
                                                    </strong>
                                                </Tooltip>
                                                <Divider type="vertical" style={{ height: "40px" }}></Divider>
                                                <Tooltip title={"The value of the Radiant Exposure based on the spot size"}>
                                                    <p style={{ "marginBottom": 1, display: 'flex', justifyContent: 'center' }}>Actual AE</p>
                                                    <strong>
                                                        <Typography style={textCenter}>
                                                            {props?.result?.MPE?.mpe_average?.result?.mpeStandard?.unit.includes("W") ? `${props?.result?.AE?.albedo_wattsPerSqmPretty}W/cm²` : `${props?.result?.AE?.albedo_joulesPerSqmPretty}J/cm²`}

                                                            {/* {(() => {
                          if (props.units === 'joules') {
                            return props.result.AE.actual_joulesPerSqmPretty;
                          } else if (props.units === 'watts') {
                            return props.result.AE.actual_wattsPerSqmPretty;
                          }
                        })()} */}
                                                        </Typography>
                                                    </strong>
                                                </Tooltip>
                                            </Space></Space>
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Eye Safety Ratio
                                            </strong>
                                            <Tooltip title={"The safety margin between the Accessible Emissionand the Maximum Permissible Exposure (MPE) limit for the eye."}>
                                                <strong style={props.result.safetyRatio?.average.albedo_joulesPerSqm > 1 ? {
                                                    ...textCenter,
                                                    color: "#d82424"
                                                } : props.result.safetyRatio?.average.albedo_joulesPerSqm <= 1 && props.result.safetyRatio?.average.albedo_joulesPerSqm >= 0.5 ? {
                                                    ...textCenter,
                                                    color: "#ffa200"
                                                } : props.result.safetyRatio?.average.albedo_joulesPerSqm < 0.5 ? {
                                                    ...textCenter,
                                                    color: "#10c96d"
                                                } : null}>
                                                    {props.result.safetyRatio?.average.albedo_joulesPerSqmPretty}
                                                </strong>
                                            </Tooltip>
                                        </Space>
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Limit Aperture
                                            </strong>
                                            <Tooltip title={"The diameter of a circular area over which the irradiance or radiant exposure is to be averaged."}>
                                                <Typography style={textCenter}>
                                                    Eye: {props.result?.limitAperture?.eye} mm
                                                </Typography>
                                                <Typography style={textCenter}>
                                                    Skin: {props.result?.limitAperture?.skin} mm
                                                </Typography>
                                            </Tooltip>
                                        </Space>
                                    </Flex>
                                </Card>
                                <Card style={{
                                    backgroundColor: (() => {
                                        if (props.result?.safetyRatio?.mostRestrictive.albedo_joulesPerSqm > 1) {
                                            return "#d82424"
                                        }
                                        else if (props.result?.safetyRatio?.mostRestrictive.albedo_joulesPerSqm <= 0.5) {
                                            return "#10c96d"
                                        }
                                        else if (props.result?.safetyRatio?.mostRestrictive.albedo_joulesPerSqm > 0.5 || props.result?.safetyRatio?.mostRestrictive.albedo_joulesPerSqm <= 1) {
                                            return "#ffa200"
                                        }
                                    })()
                                }}>
                                    <Typography style={textCenter}>
                                        <strong style={{ color: "#ffffff" }}>
                                            {(() => {
                                                if (props.result?.safetyRatio?.mostRestrictive.albedo_joulesPerSqm > 1) {
                                                    return "The configuration that has been entered is Dangerous for the Eye! "
                                                }
                                                else if (props?.result.safetyRatio?.mostRestrictive.albedo_joulesPerSqm <= 0.5) {
                                                    return "The configuration that has been entered is Safe for the Eye! "
                                                }
                                                else if (props.result?.safetyRatio?.mostRestrictive.albedo_joulesPerSqm > 0.5 || props.result?.safetyRatio?.mostRestrictive.albedo_joulesPerSqm <= 1) {
                                                    return "The configuration that has been entered is Marginally Safe for the Eye! "
                                                }
                                            })()}
                                            {props.result?.safetyRatio?.mostRestrictive.albedo_joulesPerSqmPretty} x MPE
                                        </strong>
                                    </Typography>
                                </Card>
                            </Card>

                            <Card style={{ marginBottom: "20px" }}>
                                <Divider><h4><img src={hand} width={50} style={{ marginRight: "5px" }} /><strong> SKIN </strong> </h4></Divider>

                                <Card style={{
                                    backgroundColor: (() => {
                                        if (props.result.skinMPE?.mostRestrictive === props.result.skinMPE?.mpe_multiple_pulse?.num &&
                                            props.result.skinMPE?.mostRestrictive === props.result.skinMPE?.single?.result?.mpeStandard?.num)
                                            return "#fcf151"
                                    })()
                                }}>
                                    <Flex justify="space-evenly" wrap="wrap">
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Single Pulse MPE
                                            </strong>
                                            <Tooltip title={"Maximum Permissible Exposure, this value is the level of laser radiation to which, under normal circumstances, the eye may be exposed to a single pulse laser without suffering adverse effects."}>
                                                <Typography style={textCenter}>
                                                    {props?.result?.skinMPE?.mpe_single?.result?.mpeStandard?.pretty}
                                                    {/* {(() => {
                      if (props.units === 'joules') {
                        return props.result.MPE.single.joulesPerSqmPretty.eng + 'J/m²';
                      } else if (props.units === 'watts') {
                        return props.result.MPE.single.wattsPerSqmPretty.eng + 'W/m²';
                      }
                    })()} */}

                                                </Typography>
                                            </Tooltip>
                                        </Space>
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Accessible Emission
                                            </strong>
                                            <Space>
                                                <Tooltip title={"The value of the Radiant Exposure taking into account the applicable beam area."}>
                                                    <p style={{ "marginBottom": 1, display: 'flex', justifyContent: 'center' }}>AE</p>
                                                    <strong>
                                                        <Typography style={textCenter}>
                                                            {props?.result?.skinMPE?.mpe_single?.result?.mpeStandard?.unit.includes("W") ? `${props?.result?.skinAE?.albedo_wattsPerSqmPretty}W/cm²` : `${props?.result?.skinAE?.albedo_joulesPerSqmPretty}J/cm²`}

                                                            {/* {(() => {
                          if (props.units === 'joules') {
                            return props.result.AE.joulesPerSqmPretty;
                          } else if (props.units === 'watts') {
                            return props.result.AE.wattsPerSqmPretty;
                          }
                        })()} */}
                                                        </Typography>
                                                    </strong>
                                                </Tooltip>
                                                <Divider type="vertical" style={{ height: "40px" }}></Divider>
                                                <Tooltip title={"The value of the Radiant Exposure based on the spot size"}>
                                                    <p style={{ "marginBottom": 1, display: 'flex', justifyContent: 'center' }}>Actual AE</p>
                                                    <strong>
                                                        <Typography style={textCenter}>
                                                            {props?.result?.skinMPE?.mpe_single?.result?.mpeStandard?.unit.includes("W") ? `${props?.result?.skinAE?.albedo_wattsPerSqmPretty}W/cm²` : `${props?.result?.skinAE?.albedo_joulesPerSqmPretty}J/cm²`}

                                                            {/* {(() => {
                          if (props.units === 'joules') {
                            return props.result.AE.actual_joulesPerSqmPretty;
                          } else if (props.units === 'watts') {
                            return props.result.AE.actual_wattsPerSqmPretty;
                          }
                        })()} */}
                                                        </Typography>
                                                    </strong>
                                                </Tooltip>
                                            </Space></Space>
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Skin Safety Ratio
                                            </strong>
                                            <Tooltip title={"The safety margin between the Accessible Emissionand the Maximum Permissible Exposure (MPE) limit for the eye."}>
                                                <strong style={props.result.skinSafetyRatio.single.albedo_joulesPerSqm > 1 ? {
                                                    ...textCenter,
                                                    color: "#d82424"
                                                } : props.result.skinSafetyRatio.single.albedo_joulesPerSqm <= 1 && props.result.skinSafetyRatio.single.albedo_joulesPerSqm >= 0.5 ? {
                                                    ...textCenter,
                                                    color: "#ffa200"
                                                } : props.result.skinSafetyRatio.single.albedo_joulesPerSqm < 0.5 ? {
                                                    ...textCenter,
                                                    color: "#10c96d"
                                                } : null}>
                                                    {props.result.skinSafetyRatio.single.albedo_joulesPerSqmPretty}
                                                </strong>
                                            </Tooltip>
                                        </Space>
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Limit Aperture
                                            </strong>
                                            <Tooltip title={"The diameter of a circular area over which the irradiance or radiant exposure is to be averaged."}>
                                                <Typography style={textCenter}>
                                                    Eye: {props.result?.limitAperture?.eye} mm
                                                </Typography>
                                                <Typography style={textCenter}>
                                                    Skin: {props.result?.limitAperture?.skin} mm
                                                </Typography>
                                            </Tooltip>
                                        </Space>
                                    </Flex>

                                </Card>

                                <Card style={{
                                    backgroundColor: (() => {
                                        if (props?.result?.skinMPE?.mostRestrictive === props?.result?.skinMPE?.mpe_multiple_pulse?.num &&
                                            props?.result.skinPE?.mostRestrictive === props?.result?.skinMPE?.single?.result?.mpeStandard?.num) {
                                            return null
                                        }
                                        else if (props?.result?.skinMPE?.mostRestrictive === props?.result?.skinMPE?.mpe_multiple_pulse?.num &&
                                            props?.result?.skinMPE?.mostRestrictive !== props?.result?.skinMPE?.single?.result?.mpeStandard?.num) {
                                            return "#fcf151"
                                        }
                                    })()
                                }}>
                                    <Flex justify="space-evenly" wrap="wrap">
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Pulse Train MPE
                                            </strong>
                                            <Tooltip title={"Maximum Permissible Exposure, this value is the level of laser radiation to which, under normal circumstances, the eye may be exposed to all the pulses for the duration of the exposure time frame without suffering adverse effects."}>
                                                <Typography style={textCenter}>
                                                    {props?.result?.skinMPE?.mpe_multiple_pulse?.result?.mpeStandard?.pretty}
                                                    {/* {(() => {
                      if (props.units === 'joules') {
                        return props.result.MPE.pulseTrain.joulesPerSqmPretty;
                      } else if (props.units === 'watts') {
                        return props.result.MPE.pulseTrain.wattsPerSqmPretty;
                      }
                    })()} */}
                                                </Typography>
                                            </Tooltip>
                                        </Space>
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Accessible Emission
                                            </strong>
                                            <Space>
                                                <Tooltip title={"The value of the Radiant Exposure taking into account the applicable beam area."}>
                                                    <p style={{ "marginBottom": 1, display: 'flex', justifyContent: 'center' }}>AE</p>
                                                    <strong>
                                                        <Typography style={textCenter}>
                                                            {props?.result?.skinMPE?.mpe_multiple_pulse?.result?.mpeStandard?.unit.includes("W") ? `${props?.result?.skinAE?.albedo_wattsPerSqmPretty}W/cm²` : `${props?.result?.skinAE?.albedo_joulesPerSqmPretty}J/cm²`}

                                                            {/* {(() => {
                          if (props.units === 'joules') {
                            return props.result.AE.joulesPerSqmPretty;
                          } else if (props.units === 'watts') {
                            return props.result.AE.wattsPerSqmPretty;
                          }
                        })()} */}
                                                        </Typography>
                                                    </strong>
                                                </Tooltip>
                                                <Divider type="vertical" style={{ height: "40px" }}></Divider>
                                                <Tooltip title={"The value of the Radiant Exposure based on the spot size"}>
                                                    <p style={{ "marginBottom": 1, display: 'flex', justifyContent: 'center' }}>Actual AE</p>
                                                    <strong>
                                                        <Typography style={textCenter}>
                                                            {props?.result?.skinMPE?.mpe_multiple_pulse?.result?.mpeStandard?.unit.includes("W") ? `${props?.result?.skinAE?.albedo_wattsPerSqmPretty}W/cm²` : `${props?.result?.skinAE?.albedo_joulesPerSqmPretty}J/cm²`}

                                                            {/* {(() => {
                          if (props.units === 'joules') {
                            return props.result.AE.actual_joulesPerSqmPretty;
                          } else if (props.units === 'watts') {
                            return props.result.AE.actual_wattsPerSqmPretty;
                          }
                        })()} */}
                                                        </Typography>
                                                    </strong>
                                                </Tooltip>
                                            </Space></Space>
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Skin Safety Ratio
                                            </strong>
                                            <Tooltip title={"The safety margin between the Accessible Emissionand the Maximum Permissible Exposure (MPE) limit for the eye."}>
                                                <strong style={props.result.skinSafetyRatio?.multiple_pulse.albedo_joulesPerSqm > 1 ? {
                                                    ...textCenter,
                                                    color: "#d82424"
                                                } : props.result.skinSafetyRatio?.multiple_pulse.albedo_joulesPerSqm <= 1 && props.result.skinSafetyRatio?.multiple_pulse.albedo_joulesPerSqm >= 0.5 ? {
                                                    ...textCenter,
                                                    color: "#ffa200"
                                                } : props.result.skinSafetyRatio?.multiple_pulse.albedo_joulesPerSqm < 0.5 ? {
                                                    ...textCenter,
                                                    color: "#10c96d" 
                                                } : null}>
                                                    {props.result.skinSafetyRatio?.multiple_pulse.albedo_joulesPerSqmPretty}
                                                </strong>
                                            </Tooltip>
                                        </Space>
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Limit Aperture
                                            </strong>
                                            <Tooltip title={"The diameter of a circular area over which the irradiance or radiant exposure is to be averaged."}>
                                                <Typography style={textCenter}>
                                                    Eye: {props.result?.limitAperture?.eye} mm
                                                </Typography>
                                                <Typography style={textCenter}>
                                                    Skin: {props.result?.limitAperture?.skin} mm
                                                </Typography>
                                            </Tooltip>
                                        </Space>
                                    </Flex>
                                </Card>
                                <Card style={{
                                    backgroundColor: (() => {
                                        if (props.result.skinMPE?.mostRestrictive === props.result.skinMPE?.average?.num &&
                                            props.result.skinMPE?.mostRestrictive === props.result.skinMPE?.single?.result?.mpeStandard?.num &&
                                            props.result.skinMPE?.mostRestrictive === props.result.skinMPE?.mpe_multiple_pulse?.num) {
                                            return "null"
                                        }
                                        else if (props.result.skinMPE?.mostRestrictive === props.result.skinMPE?.average?.num &&
                                            props.result.skinMPE?.mostRestrictive !== props.result.skinMPE?.single.result?.mpeStandard?.num &&
                                            props.result.skinMPE?.mostRestrictive !== props.result.skinMPE?.mpe_multiple_pulse?.num) {
                                            return "#fcf151"
                                        }
                                    })()
                                }}
                                >
                                    <Flex justify="space-evenly" wrap="wrap">
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Average MPE
                                            </strong>
                                            <Tooltip title={"Maximum Permissible Exposure, this value is the level of laser radiation to which the eye may be exposed to all the pulses for the duration of the exposure time frame without suffering adverse effects."}>
                                                <Typography style={textCenter}>
                                                    {props?.result?.skinMPE?.mpe_average?.result?.mpeStandard?.pretty}
                                                    {/* {(() => {
                      if (props.units === 'joules') {
                        return props.result.MPE.average.joulesPerSqmPretty;
                      } else if (props.units === 'watts') {
                        return props.result.MPE.average.wattsPerSqmPretty;
                      }
                    })()} */}
                                                </Typography>
                                            </Tooltip>
                                        </Space>
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Accessible Emission
                                            </strong>
                                            <Space>
                                                <Tooltip title={"The value of the Radiant Exposure taking into account the applicable beam area."}>
                                                    <p style={{ "marginBottom": 1, display: 'flex', justifyContent: 'center' }}>AE</p>
                                                    <strong>
                                                        <Typography style={textCenter}>
                                                            {props?.result?.skinMPE?.mpe_average?.result?.mpeStandard?.unit.includes("W") ? `${props?.result?.skinAE?.albedo_wattsPerSqmPretty}W/cm²` : `${props?.result?.skinAE?.albedo_joulesPerSqmPretty}J/cm²`}

                                                            {/* {(() => {
                          if (props.units === 'joules') {
                            return props.result.AE.joulesPerSqmPretty;
                          } else if (props.units === 'watts') {
                            return props.result.AE.wattsPerSqmPretty;
                          }
                        })()} */}
                                                        </Typography>
                                                    </strong>
                                                </Tooltip>
                                                <Divider type="vertical" style={{ height: "40px" }}></Divider>
                                                <Tooltip title={"The value of the Radiant Exposure based on the spot size"}>
                                                    <p style={{ "marginBottom": 1, display: 'flex', justifyContent: 'center' }}>Actual AE</p>
                                                    <strong>
                                                        <Typography style={textCenter}>
                                                            {props?.result?.skinMPE?.mpe_average?.result?.mpeStandard?.unit.includes("W") ? `${props?.result?.skinAE?.albedo_wattsPerSqmPretty}W/cm²` : `${props?.result?.skinAE?.albedo_joulesPerSqmPretty}J/cm²`}

                                                            {/* {(() => {
                          if (props.units === 'joules') {
                            return props.result.AE.actual_joulesPerSqmPretty;
                          } else if (props.units === 'watts') {
                            return props.result.AE.actual_wattsPerSqmPretty;
                          }
                        })()} */}
                                                        </Typography>
                                                    </strong>
                                                </Tooltip>
                                            </Space></Space>
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Skin Safety Ratio
                                            </strong>
                                            <Tooltip title={"The safety margin between the Accessible Emissionand the Maximum Permissible Exposure (MPE) limit for the eye."}>
                                                <strong style={props.result.skinSafetyRatio?.average.albedo_joulesPerSqm > 1 ? {
                                                    ...textCenter,
                                                    color: "#d82424"
                                                } : props.result.skinSafetyRatio?.average.albedo_joulesPerSqm <= 1 && props.result.skinSafetyRatio?.average.albedo_joulesPerSqm >= 0.5 ? {
                                                    ...textCenter,
                                                    color: "#ffa200"
                                                } : props.result.skinSafetyRatio?.average.albedo_joulesPerSqm < 0.5 ? {
                                                    ...textCenter,
                                                    color: "#10c96d"
                                                } : null}>
                                                    {props.result.skinSafetyRatio?.average.albedo_joulesPerSqmPretty}
                                                </strong>
                                            </Tooltip>
                                        </Space>
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Limit Aperture
                                            </strong>
                                            <Tooltip title={"The diameter of a circular area over which the irradiance or radiant exposure is to be averaged."}>
                                                <Typography style={textCenter}>
                                                    Eye: {props.result?.limitAperture?.eye} mm
                                                </Typography>
                                                <Typography style={textCenter}>
                                                    Skin: {props.result?.limitAperture?.skin} mm
                                                </Typography>
                                            </Tooltip>
                                        </Space>
                                    </Flex>
                                </Card>
                                <Card style={{
                                    backgroundColor: (() => {
                                        if (props.result?.skinSafetyRatio?.mostRestrictive.albedo_joulesPerSqm > 1) {
                                            return "#d82424"
                                        }
                                        else if (props.result?.skinSafetyRatio?.mostRestrictive.albedo_joulesPerSqm <= 0.5) {
                                            return "#10c96d"
                                        }
                                        else if (props.result?.skinSafetyRatio?.mostRestrictive.albedo_joulesPerSqm > 0.5 || props.result?.skinSafetyRatio?.mostRestrictive.albedo_joulesPerSqm <= 1) {
                                            return "#ffa200"
                                        }
                                    })()
                                }}>
                                    <Typography style={textCenter}>
                                        <strong style={{ color: "#ffffff" }}>
                                            {(() => {

                                                if (props.result.skinSafetyRatio.mostRestrictive.albedo_joulesPerSqm > 1) {
                                                    return "The configuration that has been entered is Dangerous for the Skin! "
                                                }
                                                else if (props.result.skinSafetyRatio.mostRestrictive.albedo_joulesPerSqm <= 0.5) {
                                                    return "The configuration that has been entered is Safe for the Skin! "
                                                }
                                                else if (props.result.skinSafetyRatio.mostRestrictive.albedo_joulesPerSqm > 0.5 || props.result.skinSafetyRatio.mostRestrictive.albedo_joulesPerSqm <= 1) {
                                                    return "The configuration that has been entered is Marginally Safe for the Skin! "
                                                }
                                            })()}
                                            {props.result?.skinSafetyRatio?.mostRestrictive.albedo_joulesPerSqmPretty} x MPE
                                        </strong>
                                    </Typography>
                                </Card>
                            </Card>
                        </>
                }, result?.albedo?.num === 100 ? null : {
                    key: 2,
                    label: "100% Albedo",
                    children:
                        <>
                            <Card style={{ marginBottom: "20px" }}>
                                <Divider> <h4><img src={eye} width={50} style={{ marginRight: "5px" }} /><strong>EYE</strong></h4></Divider>
                                <Card style={{
                                    backgroundColor: (() => {
                                        if (props.result.MPE?.mostRestrictive === props.result?.MPE?.mpe_multiple_pulse?.num &&
                                            props.result.MPE?.mostRestrictive === props.result?.MPE?.mpe_single?.result.mpeStandard.num)
                                            return "#fcf151"
                                    })()
                                }}>
                                    <Flex justify="space-evenly" wrap="wrap">
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Single Pulse MPE
                                            </strong>
                                            <Tooltip title={"Maximum Permissible Exposure, this value is the level of laser radiation to which, under normal circumstances, the eye may be exposed to a single pulse laser without suffering adverse effects."}>
                                                <Typography style={textCenter}>
                                                    {props?.result?.MPE?.mpe_single?.result?.mpeStandard?.pretty}
                                                    {/* {(() => {
                      if (props.units === 'joules') {
                        return props.result.MPE.single.joulesPerSqmPretty.eng + 'J/m²';
                      } else if (props.units === 'watts') {
                        return props.result.MPE.single.wattsPerSqmPretty.eng + 'W/m²';
                      }
                    })()} */}

                                                </Typography>
                                            </Tooltip>
                                        </Space>
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Accessible Emission
                                            </strong>
                                            <Space>
                                                <Tooltip title={"The value of the Radiant Exposure taking into account the applicable beam area."}>
                                                    <p style={{ "marginBottom": 1, display: 'flex', justifyContent: 'center' }}>AE</p>
                                                    <strong>
                                                        <Typography style={textCenter}>
                                                            {props?.result?.mpe_single?.result?.mpeStandard?.unit.includes("W") ? `${props?.result?.AE?.wattsPerSqmPretty}W/cm²` : `${props?.result?.AE?.joulesPerSqmPretty}J/cm²`}

                                                            {/* {(() => {
                          if (props.units === 'joules') {
                            return props.result.AE.joulesPerSqmPretty;
                          } else if (props.units === 'watts') {
                            return props.result.AE.wattsPerSqmPretty;
                          }
                        })()} */}
                                                        </Typography>
                                                    </strong>
                                                </Tooltip>
                                                <Divider type="vertical" style={{ height: "40px" }}></Divider>
                                                <Tooltip title={"The value of the Radiant Exposure based on the spot size"}>
                                                    <p style={{ "marginBottom": 1, display: 'flex', justifyContent: 'center' }}>Actual AE</p>
                                                    <strong>
                                                        <Typography style={textCenter}>
                                                            {props?.result?.mpe_single?.result?.mpeStandard?.unit.includes("W") ? `${props?.result?.AE?.wattsPerSqmPretty}W/cm²` : `${props?.result?.AE?.joulesPerSqmPretty}J/cm²`}

                                                            {/* {(() => {
                          if (props.units === 'joules') {
                            return props.result.AE.actual_joulesPerSqmPretty;
                          } else if (props.units === 'watts') {
                            return props.result.AE.actual_wattsPerSqmPretty;
                          }
                        })()} */}
                                                        </Typography>
                                                    </strong>
                                                </Tooltip>
                                            </Space></Space>
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Eye Safety Ratio
                                            </strong>
                                            <Tooltip title={"The safety margin between the Accessible Emissionand the Maximum Permissible Exposure (MPE) limit for the eye."}>
                                                <strong style={props.result.safetyRatio.single.joulesPerSqm > 1 ? {
                                                    ...textCenter,
                                                    color: "#d82424"
                                                } : props.result.safetyRatio.single.joulesPerSqm <= 1 && props.result.safetyRatio.single.joulesPerSqm >= 0.5 ? {
                                                    ...textCenter,
                                                    color: "#ffa200"
                                                } : props.result.safetyRatio.single.joulesPerSqm < 0.5 ? {
                                                    ...textCenter,
                                                    color: "#10c96d"
                                                } : null}>
                                                    {props.result.safetyRatio.single.joulesPerSqmPretty}
                                                </strong>
                                            </Tooltip>
                                        </Space>
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Limit Aperture
                                            </strong>
                                            <Tooltip title={"The diameter of a circular area over which the irradiance or radiant exposure is to be averaged."}>
                                                <Typography style={textCenter}>
                                                    Eye: {props.result?.limitAperture?.eye} mm
                                                </Typography>
                                                <Typography style={textCenter}>
                                                    Skin: {props.result?.limitAperture?.skin} mm
                                                </Typography>
                                            </Tooltip>
                                        </Space>
                                    </Flex>

                                </Card>

                                <Card style={{
                                    backgroundColor: (() => {
                                        if (props.result.MPE?.mostRestrictive === props.result.MPE?.mpe_multiple_pulse?.num &&
                                            props.result.MPE?.mostRestrictive === props.result.MPE?.mpe_single?.result?.mpeStandard?.num) {
                                            return null
                                        }
                                        else if (props.result.MPE?.mostRestrictive === props.result.MPE?.mpe_multiple_pulse?.num &&
                                            props.result.MPE?.mostRestrictive !== props.result.MPE?.mpe_single?.result?.mpeStandard?.num) {
                                            return "#fcf151"
                                        }
                                    })()
                                }}>
                                    <Flex justify="space-evenly" wrap="wrap">
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Pulse Train MPE
                                            </strong>
                                            <Tooltip title={"Maximum Permissible Exposure, this value is the level of laser radiation to which, under normal circumstances, the eye may be exposed to all the pulses for the duration of the exposure time frame without suffering adverse effects."}>
                                                <Typography style={textCenter}>
                                                    {props?.result?.MPE?.mpe_multiple_pulse?.result?.mpeStandard?.pretty}
                                                    {/* {(() => {
                      if (props.units === 'joules') {
                        return props.result.MPE.pulseTrain.joulesPerSqmPretty;
                      } else if (props.units === 'watts') {
                        return props.result.MPE.pulseTrain.wattsPerSqmPretty;
                      }
                    })()} */}
                                                </Typography>
                                            </Tooltip>
                                        </Space>
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Accessible Emission
                                            </strong>
                                            <Space>
                                                <Tooltip title={"The value of the Radiant Exposure taking into account the applicable beam area."}>
                                                    <p style={{ "marginBottom": 1, display: 'flex', justifyContent: 'center' }}>AE</p>
                                                    <strong>
                                                        <Typography style={textCenter}>
                                                            {props?.result?.mpe_multiple_pulse?.result?.mpeStandard?.unit.includes("W") ? `${props?.result?.AE?.wattsPerSqmPretty}W/cm²` : `${props?.result?.AE?.joulesPerSqmPretty}J/cm²`}

                                                            {/* {(() => {
                          if (props.units === 'joules') {
                            return props.result.AE.joulesPerSqmPretty;
                          } else if (props.units === 'watts') {
                            return props.result.AE.wattsPerSqmPretty;
                          }
                        })()} */}
                                                        </Typography>
                                                    </strong>
                                                </Tooltip>
                                                <Divider type="vertical" style={{ height: "40px" }}></Divider>
                                                <Tooltip title={"The value of the Radiant Exposure based on the spot size"}>
                                                    <p style={{ "marginBottom": 1, display: 'flex', justifyContent: 'center' }}>Actual AE</p>
                                                    <strong>
                                                        <Typography style={textCenter}>
                                                            {props?.result?.mpe_multiple_pulse?.result?.mpeStandard?.unit.includes("W") ? `${props?.result?.AE?.wattsPerSqmPretty}W/cm²` : `${props?.result?.AE?.joulesPerSqmPretty}J/cm²`}

                                                            {/* {(() => {
                          if (props.units === 'joules') {
                            return props.result.AE.actual_joulesPerSqmPretty;
                          } else if (props.units === 'watts') {
                            return props.result.AE.actual_wattsPerSqmPretty;
                          }
                        })()} */}
                                                        </Typography>
                                                    </strong>
                                                </Tooltip>
                                            </Space></Space>
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Eye Safety Ratio
                                            </strong>
                                            <Tooltip title={"The safety margin between the Accessible Emissionand the Maximum Permissible Exposure (MPE) limit for the eye."}>
                                                <strong style={props.result.safetyRatio?.multiple_pulse.joulesPerSqm > 1 ? {
                                                    ...textCenter,
                                                    color: "#d82424"
                                                } : props.result.safetyRatio?.multiple_pulse.joulesPerSqm <= 1 && props.result.safetyRatio?.multiple_pulse.joulesPerSqm >= 0.5 ? {
                                                    ...textCenter,
                                                    color: "#ffa200"
                                                } : props.result.safetyRatio?.multiple_pulse.joulesPerSqm < 0.5 ? {
                                                    ...textCenter,
                                                    color: "#10c96d"
                                                } : null}>
                                                    {props.result.safetyRatio?.multiple_pulse.joulesPerSqmPretty}
                                                </strong>
                                            </Tooltip>
                                        </Space>
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Limit Aperture
                                            </strong>
                                            <Tooltip title={"The diameter of a circular area over which the irradiance or radiant exposure is to be averaged."}>
                                                <Typography style={textCenter}>
                                                    Eye: {props.result?.limitAperture?.eye} mm
                                                </Typography>
                                                <Typography style={textCenter}>
                                                    Skin: {props.result?.limitAperture?.skin} mm
                                                </Typography>
                                            </Tooltip>
                                        </Space>
                                    </Flex>
                                </Card>
                                <Card style={{
                                    backgroundColor: (() => {
                                        if (props.result.MPE?.mostRestrictive === props.result.MPE?.mpe_average.num &&
                                            props.result.MPE?.mostRestrictive === props.result.MPE?.mpe_single.result.mpeStandard.num &&
                                            props.result.MPE?.mostRestrictive === props.result.MPE?.mpe_multiple_pulse?.num) {
                                            return "null"
                                        }
                                        else if (props.result.MPE?.mostRestrictive === props.result.MPE?.mpe_average.num &&
                                            props.result.MPE?.mostRestrictive !== props.result.MPE?.mpe_single.result.mpeStandard.num &&
                                            props.result.MPE?.mostRestrictive !== props.result.MPE?.mpe_multiple_pulse?.num) {
                                            return "#fcf151"
                                        }
                                    })()
                                }}
                                >
                                    <Flex justify="space-evenly" wrap="wrap">
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Average MPE
                                            </strong>
                                            <Tooltip title={"Maximum Permissible Exposure, this value is the level of laser radiation to which the eye may be exposed to all the pulses for the duration of the exposure time frame without suffering adverse effects."}>
                                                <Typography style={textCenter}>
                                                    {props?.result?.MPE?.mpe_average?.result?.mpeStandard?.pretty}
                                                    {/* {(() => {
                      if (props.units === 'joules') {
                        return props.result.MPE.average.joulesPerSqmPretty;
                      } else if (props.units === 'watts') {
                        return props.result.MPE.average.wattsPerSqmPretty;
                      }
                    })()} */}
                                                </Typography>
                                            </Tooltip>
                                        </Space>
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Accessible Emission
                                            </strong>
                                            <Space>
                                                <Tooltip title={"The value of the Radiant Exposure taking into account the applicable beam area."}>
                                                    <p style={{ "marginBottom": 1, display: 'flex', justifyContent: 'center' }}>AE</p>
                                                    <strong>
                                                        <Typography style={textCenter}>
                                                            {props?.result?.mpe_average?.result?.mpeStandard?.unit.includes("W") ? `${props?.result?.AE?.wattsPerSqmPretty}W/cm²` : `${props?.result?.AE?.joulesPerSqmPretty}J/cm²`}

                                                            {/* {(() => {
                          if (props.units === 'joules') {
                            return props.result.AE.joulesPerSqmPretty;
                          } else if (props.units === 'watts') {
                            return props.result.AE.wattsPerSqmPretty;
                          }
                        })()} */}
                                                        </Typography>
                                                    </strong>
                                                </Tooltip>
                                                <Divider type="vertical" style={{ height: "40px" }}></Divider>
                                                <Tooltip title={"The value of the Radiant Exposure based on the spot size"}>
                                                    <p style={{ "marginBottom": 1, display: 'flex', justifyContent: 'center' }}>Actual AE</p>
                                                    <strong>
                                                        <Typography style={textCenter}>
                                                            {props?.result?.mpe_average?.result?.mpeStandard?.unit.includes("W") ? `${props?.result?.AE?.wattsPerSqmPretty}W/cm²` : `${props?.result?.AE?.joulesPerSqmPretty}J/cm²`}

                                                            {/* {(() => {
                          if (props.units === 'joules') {
                            return props.result.AE.actual_joulesPerSqmPretty;
                          } else if (props.units === 'watts') {
                            return props.result.AE.actual_wattsPerSqmPretty;
                          }
                        })()} */}
                                                        </Typography>
                                                    </strong>
                                                </Tooltip>
                                            </Space></Space>
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Eye Safety Ratio
                                            </strong>
                                            <Tooltip title={"The safety margin between the Accessible Emissionand the Maximum Permissible Exposure (MPE) limit for the eye."}>
                                                <strong style={props.result.safetyRatio?.average.joulesPerSqm > 1 ? {
                                                    ...textCenter,
                                                    color: "#d82424"
                                                } : props.result.safetyRatio?.average.joulesPerSqm <= 1 && props.result.safetyRatio?.average.joulesPerSqm >= 0.5 ? {
                                                    ...textCenter,
                                                    color: "#ffa200"
                                                } : props.result.safetyRatio?.average.joulesPerSqm < 0.5 ? {
                                                    ...textCenter,
                                                    color: "#10c96d"
                                                } : null}>
                                                    {props.result.safetyRatio?.average.joulesPerSqmPretty}
                                                </strong>
                                            </Tooltip>
                                        </Space>
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Limit Aperture
                                            </strong>
                                            <Tooltip title={"The diameter of a circular area over which the irradiance or radiant exposure is to be averaged."}>
                                                <Typography style={textCenter}>
                                                    Eye: {props.result?.limitAperture?.eye} mm
                                                </Typography>
                                                <Typography style={textCenter}>
                                                    Skin: {props.result?.limitAperture?.skin} mm
                                                </Typography>
                                            </Tooltip>
                                        </Space>
                                    </Flex>
                                </Card>
                                <Card style={{
                                    backgroundColor: (() => {
                                        if (props.result?.safetyRatio?.mostRestrictive.joulesPerSqm > 1) {
                                            return "#d82424"
                                        }
                                        else if (props.result?.safetyRatio?.mostRestrictive.joulesPerSqm <= 0.5) {
                                            return "#10c96d"
                                        }
                                        else if (props.result?.safetyRatio?.mostRestrictive.joulesPerSqm > 0.5 || props.result?.safetyRatio?.mostRestrictive.joulesPerSqm <= 1) {
                                            return "#ffa200"
                                        }
                                    })()
                                }}>
                                    <Typography style={textCenter}>
                                        <strong style={{ color: "#ffffff" }}>
                                            {(() => {
                                                if (props.result?.safetyRatio?.mostRestrictive.joulesPerSqm > 1) {
                                                    return "The configuration that has been entered is Dangerous for the Eye! "
                                                }
                                                else if (props?.result.safetyRatio?.mostRestrictive.joulesPerSqm <= 0.5) {
                                                    return "The configuration that has been entered is Safe for the Eye! "
                                                }
                                                else if (props.result?.safetyRatio?.mostRestrictive.joulesPerSqm > 0.5 || props.result?.safetyRatio?.mostRestrictive.joulesPerSqm <= 1) {
                                                    return "The configuration that has been entered is Marginally Safe for the Eye! "
                                                }
                                            })()}
                                            {props.result?.safetyRatio?.mostRestrictive.joulesPerSqmPretty} x MPE
                                        </strong>
                                    </Typography>
                                </Card>
                            </Card>

                            <Card style={{ marginBottom: "20px" }}>
                                <Divider><h4><img src={hand} width={50} style={{ marginRight: "5px" }} /><strong> SKIN </strong> </h4></Divider>

                                <Card style={{
                                    backgroundColor: (() => {
                                        if (props.result.skinMPE?.mostRestrictive === props.result.skinMPE?.mpe_multiple_pulse?.num &&
                                            props.result.skinMPE?.mostRestrictive === props.result.skinMPE?.single?.result?.mpeStandard?.num)
                                            return "#fcf151"
                                    })()
                                }}>
                                    <Flex justify="space-evenly" wrap="wrap">
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Single Pulse MPE
                                            </strong>
                                            <Tooltip title={"Maximum Permissible Exposure, this value is the level of laser radiation to which, under normal circumstances, the eye may be exposed to a single pulse laser without suffering adverse effects."}>
                                                <Typography style={textCenter}>
                                                    {props?.result?.skinMPE?.mpe_single?.result?.mpeStandard?.pretty}
                                                    {/* {(() => {
                      if (props.units === 'joules') {
                        return props.result.MPE.single.joulesPerSqmPretty.eng + 'J/m²';
                      } else if (props.units === 'watts') {
                        return props.result.MPE.single.wattsPerSqmPretty.eng + 'W/m²';
                      }
                    })()} */}

                                                </Typography>
                                            </Tooltip>
                                        </Space>
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Accessible Emission
                                            </strong>
                                            <Space>
                                                <Tooltip title={"The value of the Radiant Exposure taking into account the applicable beam area."}>
                                                    <p style={{ "marginBottom": 1, display: 'flex', justifyContent: 'center' }}>AE</p>
                                                    <strong>
                                                        <Typography style={textCenter}>
                                                            {props?.result?.skinMPE.mpe_single?.result?.mpeStandard?.unit.includes("W") ? `${props?.result?.skinAE?.wattsPerSqmPretty}W/cm²` : `${props?.result?.skinAE?.joulesPerSqmPretty}J/cm²`}

                                                            {/* {(() => {
                          if (props.units === 'joules') {
                            return props.result.AE.joulesPerSqmPretty;
                          } else if (props.units === 'watts') {
                            return props.result.AE.wattsPerSqmPretty;
                          }
                        })()} */}
                                                        </Typography>
                                                    </strong>
                                                </Tooltip>
                                                <Divider type="vertical" style={{ height: "40px" }}></Divider>
                                                <Tooltip title={"The value of the Radiant Exposure based on the spot size"}>
                                                    <p style={{ "marginBottom": 1, display: 'flex', justifyContent: 'center' }}>Actual AE</p>
                                                    <strong>
                                                        <Typography style={textCenter}>
                                                            {props?.result?.skinMPE.mpe_single?.result?.mpeStandard?.unit.includes("W") ? `${props?.result?.skinAE?.wattsPerSqmPretty}W/cm²` : `${props?.result?.skinAE?.joulesPerSqmPretty}J/cm²`}

                                                            {/* {(() => {
                          if (props.units === 'joules') {
                            return props.result.AE.actual_joulesPerSqmPretty;
                          } else if (props.units === 'watts') {
                            return props.result.AE.actual_wattsPerSqmPretty;
                          }
                        })()} */}
                                                        </Typography>
                                                    </strong>
                                                </Tooltip>
                                            </Space></Space>
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Skin Safety Ratio
                                            </strong>
                                            <Tooltip title={"The safety margin between the Accessible Emissionand the Maximum Permissible Exposure (MPE) limit for the eye."}>
                                                <strong style={props.result.skinSafetyRatio?.single.joulesPerSqm > 1 ? {
                                                    ...textCenter,
                                                    color: "#d82424"
                                                } : props.result.skinSafetyRatio?.single.joulesPerSqm <= 1 && props.result.skinSafetyRatio?.single.joulesPerSqm >= 0.5 ? {
                                                    ...textCenter,
                                                    color: "#ffa200"
                                                } : props.result.skinSafetyRatio?.single.joulesPerSqm < 0.5 ? {
                                                    ...textCenter,
                                                    color: "#10c96d"
                                                } : null}>
                                                    {props.result.skinSafetyRatio?.single?.joulesPerSqmPretty}
                                                </strong>
                                            </Tooltip>
                                        </Space>
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Limit Aperture
                                            </strong>
                                            <Tooltip title={"The diameter of a circular area over which the irradiance or radiant exposure is to be averaged."}>
                                                <Typography style={textCenter}>
                                                    Eye: {props.result?.limitAperture?.eye} mm
                                                </Typography>
                                                <Typography style={textCenter}>
                                                    Skin: {props.result?.limitAperture?.skin} mm
                                                </Typography>
                                            </Tooltip>
                                        </Space>
                                    </Flex>

                                </Card>

                                <Card style={{
                                    backgroundColor: (() => {
                                        if (props?.result?.skinMPE?.mostRestrictive === props?.result?.skinMPE?.mpe_multiple_pulse?.num &&
                                            props?.result.skinPE?.mostRestrictive === props?.result?.skinMPE?.single?.result?.mpeStandard?.num) {
                                            return null
                                        }
                                        else if (props?.result?.skinMPE?.mostRestrictive === props?.result?.skinMPE?.mpe_multiple_pulse?.num &&
                                            props?.result?.skinMPE?.mostRestrictive !== props?.result?.skinMPE?.single?.result?.mpeStandard?.num) {
                                            return "#fcf151"
                                        }
                                    })()
                                }}>
                                    <Flex justify="space-evenly" wrap="wrap">
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Pulse Train MPE
                                            </strong>
                                            <Tooltip title={"Maximum Permissible Exposure, this value is the level of laser radiation to which, under normal circumstances, the eye may be exposed to all the pulses for the duration of the exposure time frame without suffering adverse effects."}>
                                                <Typography style={textCenter}>
                                                    {props?.result?.skinMPE?.mpe_multiple_pulse?.result?.mpeStandard?.pretty}
                                                    {/* {(() => {
                      if (props.units === 'joules') {
                        return props.result.MPE.pulseTrain.joulesPerSqmPretty;
                      } else if (props.units === 'watts') {
                        return props.result.MPE.pulseTrain.wattsPerSqmPretty;
                      }
                    })()} */}
                                                </Typography>
                                            </Tooltip>
                                        </Space>
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Accessible Emission
                                            </strong>
                                            <Space>
                                                <Tooltip title={"The value of the Radiant Exposure taking into account the applicable beam area."}>
                                                    <p style={{ "marginBottom": 1, display: 'flex', justifyContent: 'center' }}>AE</p>
                                                    <strong>
                                                        <Typography style={textCenter}>
                                                            {props?.result?.skinMPE.mpe_multiple_pulse?.result?.mpeStandard?.unit.includes("W") ? `${props?.result?.skinAE?.wattsPerSqmPretty}W/cm²` : `${props?.result?.skinAE?.joulesPerSqmPretty}J/cm²`}

                                                            {/* {(() => {
                          if (props.units === 'joules') {
                            return props.result.AE.joulesPerSqmPretty;
                          } else if (props.units === 'watts') {
                            return props.result.AE.wattsPerSqmPretty;
                          }
                        })()} */}
                                                        </Typography>
                                                    </strong>
                                                </Tooltip>
                                                <Divider type="vertical" style={{ height: "40px" }}></Divider>
                                                <Tooltip title={"The value of the Radiant Exposure based on the spot size"}>
                                                    <p style={{ "marginBottom": 1, display: 'flex', justifyContent: 'center' }}>Actual AE</p>
                                                    <strong>
                                                        <Typography style={textCenter}>
                                                            {props?.result?.skinMPE.mpe_multiple_pulse?.result?.mpeStandard?.unit.includes("W") ? `${props?.result?.skinAE?.wattsPerSqmPretty}W/cm²` : `${props?.result?.skinAE?.joulesPerSqmPretty}J/cm²`}

                                                            {/* {(() => {
                          if (props.units === 'joules') {
                            return props.result.AE.actual_joulesPerSqmPretty;
                          } else if (props.units === 'watts') {
                            return props.result.AE.actual_wattsPerSqmPretty;
                          }
                        })()} */}
                                                        </Typography>
                                                    </strong>
                                                </Tooltip>
                                            </Space></Space>
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Skin Safety Ratio
                                            </strong>
                                            <Tooltip title={"The safety margin between the Accessible Emissionand the Maximum Permissible Exposure (MPE) limit for the eye."}>
                                                <strong style={props.result.skinSafetyRatio?.multiple_pulse.joulesPerSqm > 1 ? {
                                                    ...textCenter,
                                                    color: "#d82424"
                                                } : props.result.skinSafetyRatio?.multiple_pulse.joulesPerSqm <= 1 && props.result.skinSafetyRatio?.multiple_pulse.joulesPerSqm >= 0.5 ? {
                                                    ...textCenter,
                                                    color: "#ffa200"
                                                } : props.result.skinSafetyRatio?.multiple_pulse.joulesPerSqm < 0.5 ? {
                                                    ...textCenter,
                                                    color: "#10c96d"
                                                } : null}>
                                                    {props.result.skinSafetyRatio?.multiple_pulse.joulesPerSqmPretty}
                                                </strong>
                                            </Tooltip>
                                        </Space>
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Limit Aperture
                                            </strong>
                                            <Tooltip title={"The diameter of a circular area over which the irradiance or radiant exposure is to be averaged."}>
                                                <Typography style={textCenter}>
                                                    Eye: {props.result?.limitAperture?.eye} mm
                                                </Typography>
                                                <Typography style={textCenter}>
                                                    Skin: {props.result?.limitAperture?.skin} mm
                                                </Typography>
                                            </Tooltip>
                                        </Space>
                                    </Flex>
                                </Card>
                                <Card style={{
                                    backgroundColor: (() => {
                                        if (props.result.skinMPE?.mostRestrictive === props.result.skinMPE?.average?.num &&
                                            props.result.skinMPE?.mostRestrictive === props.result.skinMPE?.single?.result?.mpeStandard?.num &&
                                            props.result.skinMPE?.mostRestrictive === props.result.skinMPE?.mpe_multiple_pulse?.num) {
                                            return "null"
                                        }
                                        else if (props.result.skinMPE?.mostRestrictive === props.result.skinMPE?.average?.num &&
                                            props.result.skinMPE?.mostRestrictive !== props.result.skinMPE?.single.result?.mpeStandard?.num &&
                                            props.result.skinMPE?.mostRestrictive !== props.result.skinMPE?.mpe_multiple_pulse?.num) {
                                            return "#fcf151"
                                        }
                                    })()
                                }}
                                >
                                    <Flex justify="space-evenly" wrap="wrap">
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Average MPE
                                            </strong>
                                            <Tooltip title={"Maximum Permissible Exposure, this value is the level of laser radiation to which the eye may be exposed to all the pulses for the duration of the exposure time frame without suffering adverse effects."}>
                                                <Typography style={textCenter}>
                                                    {props?.result?.skinMPE?.mpe_average?.result?.mpeStandard?.pretty}
                                                    {/* {(() => {
                      if (props.units === 'joules') {
                        return props.result.MPE.average.joulesPerSqmPretty;
                      } else if (props.units === 'watts') {
                        return props.result.MPE.average.wattsPerSqmPretty;
                      }
                    })()} */}
                                                </Typography>
                                            </Tooltip>
                                        </Space>
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Accessible Emission
                                            </strong>
                                            <Space>
                                                <Tooltip title={"The value of the Radiant Exposure taking into account the applicable beam area."}>
                                                    <p style={{ "marginBottom": 1, display: 'flex', justifyContent: 'center' }}>AE</p>
                                                    <strong>
                                                        <Typography style={textCenter}>
                                                            {props?.result?.skinMPE.mpe_average?.result?.mpeStandard?.unit.includes("W") ? `${props?.result?.skinAE?.wattsPerSqmPretty}W/cm²` : `${props?.result?.skinAE?.joulesPerSqmPretty}J/cm²`}

                                                            {/* {(() => {
                          if (props.units === 'joules') {
                            return props.result.AE.joulesPerSqmPretty;
                          } else if (props.units === 'watts') {
                            return props.result.AE.wattsPerSqmPretty;
                          }
                        })()} */}
                                                        </Typography>
                                                    </strong>
                                                </Tooltip>
                                                <Divider type="vertical" style={{ height: "40px" }}></Divider>
                                                <Tooltip title={"The value of the Radiant Exposure based on the spot size"}>
                                                    <p style={{ "marginBottom": 1, display: 'flex', justifyContent: 'center' }}>Actual AE</p>
                                                    <strong>
                                                        <Typography style={textCenter}>
                                                            {props?.result?.skinMPE.mpe_average?.result?.mpeStandard?.unit.includes("W") ? `${props?.result?.skinAE?.wattsPerSqmPretty}W/cm²` : `${props?.result?.skinAE?.joulesPerSqmPretty}J/cm²`}

                                                            {/* {(() => {
                          if (props.units === 'joules') {
                            return props.result.AE.actual_joulesPerSqmPretty;
                          } else if (props.units === 'watts') {
                            return props.result.AE.actual_wattsPerSqmPretty;
                          }
                        })()} */}
                                                        </Typography>
                                                    </strong>
                                                </Tooltip>
                                            </Space></Space>
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Skin Safety Ratio
                                            </strong>
                                            <Tooltip title={"The safety margin between the Accessible Emissionand the Maximum Permissible Exposure (MPE) limit for the eye."}>
                                                <strong style={props.result.skinSafetyRatio?.average.joulesPerSqm > 1 ? {
                                                    ...textCenter,
                                                    color: "#d82424"
                                                } : props.result.skinSafetyRatio?.average.joulesPerSqm <= 1 && props.result.skinSafetyRatio?.average.joulesPerSqm >= 0.5 ? {
                                                    ...textCenter,
                                                    color: "#ffa200"
                                                } : props.result.skinSafetyRatio?.average.joulesPerSqm < 0.5 ? {
                                                    ...textCenter,
                                                    color: "#10c96d"
                                                } : null}>
                                                    {props.result.skinSafetyRatio?.average.joulesPerSqmPretty}
                                                </strong>
                                            </Tooltip>
                                        </Space>
                                        <Space direction="vertical">
                                            <strong style={textCenter}>
                                                Limit Aperture
                                            </strong>
                                            <Tooltip title={"The diameter of a circular area over which the irradiance or radiant exposure is to be averaged."}>
                                                <Typography style={textCenter}>
                                                    Eye: {props.result?.limitAperture?.eye} mm
                                                </Typography>
                                                <Typography style={textCenter}>
                                                    Skin: {props.result?.limitAperture?.skin} mm
                                                </Typography>
                                            </Tooltip>
                                        </Space>
                                    </Flex>
                                </Card>
                                <Card style={{
                                    backgroundColor: (() => {
                                        if (props.result?.skinSafetyRatio?.mostRestrictive.joulesPerSqm > 1) {
                                            return "#d82424"
                                        }
                                        else if (props.result?.skinSafetyRatio?.mostRestrictive.joulesPerSqm <= 0.5) {
                                            return "#10c96d"
                                        }
                                        else if (props.result?.skinSafetyRatio?.mostRestrictive.joulesPerSqm > 0.5 || props.result?.skinSafetyRatio?.mostRestrictive.joulesPerSqm <= 1) {
                                            return "#ffa200"
                                        }
                                    })()
                                }}>
                                    <Typography style={textCenter}>
                                        <strong style={{ color: "#ffffff" }}>
                                            {(() => {

                                                if (props.result.skinSafetyRatio?.mostRestrictive.joulesPerSqm > 1) {
                                                    return "The configuration that has been entered is Dangerous for the Skin! "
                                                }
                                                else if (props.result.skinSafetyRatio?.mostRestrictive.joulesPerSqm <= 0.5) {
                                                    return "The configuration that has been entered is Safe for the Skin! "
                                                }
                                                else if (props.result.skinSafetyRatio?.mostRestrictive.joulesPerSqm > 0.5 || props.result.skinSafetyRatio?.mostRestrictive.joulesPerSqm <= 1) {
                                                    return "The configuration that has been entered is Marginally Safe for the Skin! "
                                                }
                                            })()}
                                            {props.result?.skinSafetyRatio?.mostRestrictive.joulesPerSqmPretty} x MPE
                                        </strong>
                                    </Typography>
                                </Card>
                            </Card>
                        </>
                }]} />
                <Card>
                    <Divider><h4><img src={beam} width={50} /> <strong>BEAM PROPERTIES</strong></h4></Divider>
                    <Flex justify={"center"} wrap="wrap"  >

                        <ResultCard>
                            <div onClick={() => { handleClick("NOHD") }} style={{ cursor: "pointer" }}>
                                <Flex justify="center"><strong>NOHD</strong></Flex>
                                <Flex justify="center">
                                    {(() => {
                                        if (result?.NOHD?.isError === true || result?.NOHD?.isError === undefined || result?.NOHD?.isError === null) {
                                            return <Tooltip title={result?.NOHD?.message}>N/A</Tooltip>
                                        } else {
                                            return result?.NOHD?.value?.pretty
                                        }
                                    })()}
                                </Flex>
                            </div>
                        </ResultCard>

                        <ResultCard>
                            <div onClick={() => { handleClick("ENOHD") }} style={{ cursor: "pointer" }}>
                                <Flex justify="center"><strong>ENOHD</strong></Flex>
                                {/* <Flex justify="center">{result?.ENOHD?.val !== null ? result.ENOHD.value.pretty : 'N/A'}</Flex> */}
                                <Flex justify="center">
                                    {(() => {
                                        if (result?.ENOHD?.isError === true || result?.ENOHD?.isError === undefined || result?.ENOHD?.isError === null) {
                                            return <Tooltip title='ENOHD is only applicable for wavelengths  between 302.5nm ~ 10⁶nm'>N/A</Tooltip>
                                        } else {
                                            return result?.ENOHD?.value?.pretty
                                        }
                                    })()}
                                </Flex>
                            </div>
                        </ResultCard>

                        <ResultCard>
                            <div onClick={() => { handleClick("Spot Size") }} style={{ cursor: "pointer" }}>
                                <Flex justify="center"><strong>Spot Size</strong></Flex>
                                <Flex justify="center">{result?.outputBeamDiameter}</Flex>
                            </div>
                        </ResultCard>

                        <ResultCard>
                            <div onClick={() => { handleClick("limit aperture") }} style={{ cursor: "pointer" }}>
                                <Flex justify="center"><strong>Limit Aperture</strong></Flex>
                                <Flex justify="center">{result?.limitAperture?.eye + ' mm'}</Flex>
                                <Flex justify="center">{result?.limitAperture?.skin + ' mm'}</Flex>
                            </div>
                        </ResultCard>

                        <ResultCard>
                            <div onClick={() => { handleClick("applicable beam area") }} style={{ cursor: "pointer" }}>
                                <Space direction="vertical">
                                    <Flex justify="center"><strong>Beam Area</strong></Flex>
                                    <Flex justify="center">
                                        <Space direction="vertical">
                                            <Flex justify="center"><strong>Eye:</strong></Flex>
                                            <Flex>{result?.applicableBeamArea?.prettiest}</Flex>
                                        </Space>
                                        <Divider orientation="center" type="vertical" />
                                        <Space direction="vertical">
                                            <Flex><strong>Skin:</strong></Flex>
                                            <Flex>{result?.skinApplicableBeamArea?.prettiest}</Flex>
                                        </Space>
                                    </Flex>
                                </Space>
                            </div>
                        </ResultCard>


                        <ResultCard style={{ width: "200px", height: "100px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <div onClick={() => { handleClick("spectrum") }} style={{ cursor: "pointer" }}>
                                <strong> Spectrum</strong>
                                <Row justify={"center"}>
                                    <div style={{
                                        width: "30px",
                                        height: "30px",
                                        backgroundColor: (() => {
                                            if (result?.spectrum?.range == "Infrared") {
                                                return "maroon"
                                            }
                                            else if (result?.spectrum?.range == "Ultraviolet") {
                                                return "purple"
                                            }
                                            return "rgb(" + result?.spectrum?.rgb + ")"
                                        })(),
                                        borderRadius: 100,
                                        ustifyContent: "center"
                                    }}>
                                    </div>
                                </Row>
                                <Row justify={"center"}>{result?.spectrum?.region}</Row>
                            </div>
                        </ResultCard>
                    </Flex>
                </Card>

            </>
        )
    }, {
        disabled: isFree,
        key: 2,
        label: "More information",
        children:
            <>
                {/* <Divider>Correction Factors and Break Points</Divider> */}
                <Row justify="center">
                    <Divider orientation="center">
                        Correction Factors & Time Bases
                    </Divider>
                    {Object.entries(props.result?.correctionFactors || {}).map(([key, cf]) => {
                        if (cf.num !== null) {
                            return (
                                <ResultCard key={key}>
                                    <strong style={textCenter}>
                                        {key}
                                    </strong>
                                    <Typography>{cf.pretty}</Typography>
                                </ResultCard>
                            );
                        }
                    })}
                </Row>
                {/* <Divider>Angular Parameters</Divider>
                <Flex justify="center">
                    <Space>
                        <Card>
                            <Space direction="vertical">
                                <Flex justify="center"><strong>Angular Subtense (diffused)</strong></Flex>
                                <Flex justify="center">{result?.angularSubtense}</Flex>
                            </Space>
                        </Card>

                        {/* <Card>
                            <Space direction="vertical">
                                <Flex justify="center"><strong>Angle of Acceptance</strong></Flex>
                                <Flex justify="center">{result.MPE.angleOfAcceptancePretty}</Flex>
                            </Space>
                        </Card> */}
                        {/*
                        <Card>
                            <Space direction="vertical">
                                <Flex justify="center"><strong>Alpha max</strong></Flex>
                                <Flex justify="center">1.3rad</Flex>
                            </Space>
                        </Card> 
                    </Space>

                </Flex> */}

            </>
    }, {
        key: 3,
        label: "Laser Class Details",
        children:
            <>
                <Divider orientation="center">  Accessible Emission Limits </Divider>
                {/* <LaserClassResultsV2 laserClass={result.laserClass} condition={1} />
                    <LaserClassResultsV2 laserClass={result.laserClass} condition={3} /> */}

                {/* <LaserClassResultsDiffuseReflective result={result} condition={1} laserOperation={laserOperation}/>
                <br />
                <LaserClassResultsDiffuseReflective result={result} condition={3} laserOperation={laserOperation}/> */}
                {/* <AllAELDiffuse result={result} laserOperation={laserOperation} /> */}
                <AllAELANSI props={props} />


            </>
    }, {
        disabled: isFree,
        key: 4,
        label: "Laser Protective Eyewear",
        children: <>
            <EyewearResultsANSI props={props} />
            <Row justify={'center'}>
                <Eyewear />
            </Row></>
    }]} />);
}
